import React from 'react';
import { forwardRef } from 'react';

interface MapControlMenuOptionProps {
    label: string;
    active: boolean;
    iconName: string;
    onClick: () => void;
}
const MapControlMenuOption = forwardRef<HTMLButtonElement, MapControlMenuOptionProps>(
    ({ label, onClick, active, iconName }, ref) => (
        <button
            ref={ref}
            type="button"
            className="c-map-control-menu__option o-btn-square"
            title={label}
            onClick={onClick}
        >
            <i
                className={`${iconName} c-map-control-menu__option-icon
                        ${active ? `${iconName}--active` : ''}`}
            />
            <span
                className={`o-btn-square__title
                        ${active ? 'c-map-control-menu__active-text' : ''}`}
            >
                {label}
            </span>
        </button>
    )
);
MapControlMenuOption.displayName = 'MapControlMenuOption';
export { MapControlMenuOption };
